import React, { useContext, useState } from "react";
import "../css/navbar.css";
import { authenticatedContext, userDataContext } from "../App";
import { logout } from "../helpers/auth";

import { Link, useLocation } from "react-router-dom";

function Navbar(props) {
  const location = useLocation()
  const path = location.pathname

  const { authenticated, setAuthenticated } = useContext(authenticatedContext);
  const { userData, setUserData } = useContext(userDataContext);
  const [isOpen, setOpen] = useState(false);

  function logoutUser() {
    logout();
    setAuthenticated(false);
  }

  function closeMenu() {
    setOpen(false);
  }


  if (userData === null) return null;
  return (
    <div className="navbars">
      {<div className="desktop-navbar">
        <Link to="/">
        <img
          src="/img/svg/logo_sm.svg"
          alt="Company Logo"
          className="navbar-logo"
        />
        </Link>
        <nav className="menu">
          <Link to="/">
            <div id="1" className={'/' === path ? 'menu-item menu-item-selected' : 'menu-item'}>
              <img src="/img/svg/overview.svg" className="menu-icon" />
              <div className="menu-item-title"> Přehled </div>
            </div>
          </Link>
          <Link to="/clients">
            <div id="2" className={'/clients' === path ? 'menu-item menu-item-selected' : 'menu-item'}>
              <img src="/img/svg/clients_w.svg" className="menu-icon" />
              <div className="menu-item-title"> Klienti </div>
            </div>
          </Link>
          <Link to="/aid_records">
            <div id="3" className={'/aid_records' === path ? 'menu-item menu-item-selected' : 'menu-item'}>
              <img src="/img/svg/records.svg" className="menu-icon" />
              <div className="menu-item-title"> Záznamy o pomoci </div>
            </div>
          </Link>
          <div id="" className={('/project_admin' === path || '/app_user_admin' === path) ? 'menu-item menu-item-dropdown-butt menu-item-selected' : 'menu-item menu-item-dropdown-butt'}>
            <img src="/img/svg/edit_w.svg" className="menu-icon" />
            <div className="menu-item-title"> Administrace </div>
            <div className="dropdown-items">
              <Link to="/project_admin">
                <div>Projekty</div>
              </Link>
              <Link to="/app_user_admin">
                <div>Uživatelské účty</div>
              </Link>
            </div>
          </div>

        </nav>
        <div className="user-info">
          <img
            src="/img/user_in_circle.png"
            alt="User icon"
            className="user-icon"
          />
          <div className="user-name">{userData.first_name} {userData.last_name}</div>
          <img src="/img/down_arrow.png" alt="Settings icon" />

          <section className="profile-card">
            <figure className="profile-image-wrapper">
              <img
                src="/img/user_in_circle_100_100.png"
                alt="User Profile"
                className="profile-image"
              />
            </figure>
            <div className="profile-user-info">
              <h2 className="profile-user-name">{userData.first_name} {userData.last_name}</h2>
              <p className="card-email">{userData.email}</p>
            </div>
            <button className="logout-button" onClick={logoutUser}>Odhlásit se</button>
          </section>
        </div>
      </div>}
      <div className="mobile-navbar">
        <div>
          <div className="mobile-header">
            <Link to="/" onClick={closeMenu}>
              <img
                src="/img/logo_text_sm.png"
                alt="Company Logo"
                className="navbar-logo"
              />
              </Link>
              <button
                onClick={() => setOpen(!isOpen)}
                className={`hamburger-button ${isOpen ? "open" : "close"}`}
              />
          </div>
          <div className={`panel ${isOpen ? "open" : "close"}`}>
            <Link to="/"onClick={closeMenu}>
            <div id="10" className={'/' === path ? 'mob-menu-item mob-menu-item-selected' : 'mob-menu-item'}>
              <img src="/img/svg/overview.svg" className="mob-menu-icon" />
              <div className="mob-menu-item-title">Přehled </div>
            </div>
          </Link>
          <Link to="/clients" onClick={closeMenu}>
            <div id="11" className={'/clients' === path ? 'mob-menu-item mob-menu-item-selected' : 'mob-menu-item'}>
              <img src="/img/svg/clients_w.svg" className="mob-menu-icon" />
              <div className="mob-menu-item-title">Klienti </div>
            </div>
          </Link>
          <Link to="/aid_records" onClick={closeMenu}>
            <div id="12" className={'/aid_records' === path ? 'mob-menu-item mob-menu-item-selected' : 'mob-menu-item'}>
              <img src="/img/svg/records.svg" className="mob-menu-icon" />
              <div className="mob-menu-item-title">Záznamy o pomoci </div>
            </div>
          </Link>

          <Link to="/project_admin" onClick={closeMenu}>
            <div id="13" className={'/project_admin' === path ? 'mob-menu-item mob-menu-item-selected' : 'mob-menu-item'}>
              <img src="/img/svg/projects_w.svg" className="mob-menu-icon" />
              <div className="mob-menu-item-title">Projekty </div>
            </div>
          </Link>

          <Link to="/app_user_admin" onClick={closeMenu}>
            <div id="14" className={'/app_user_admin' === path ? 'mob-menu-item mob-menu-item-selected' : 'mob-menu-item'}>
              <img src="/img/svg/account_w.svg" className="mob-menu-icon" />
              <div className="mob-menu-item-title">Uživatelské účty </div>
            </div>
          </Link>

          <div id="15" className='mob-menu-item' onClick={logoutUser}>
              <img src="/img/svg/leave_w.svg" className="mob-menu-icon" />
              <div className="mob-menu-item-title">Odhlásit se </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Navbar;
